<table class="tabellarische-maske-table">
    <thead>
        <ng-content select="[tabellarische-maske-table-header]"></ng-content>
    </thead>
    <tbody>
        <ng-content select="[tabellarische-maske-table-body]"></ng-content>
    </tbody>
</table>
